module.exports = __webpack_public_path__ + "img/9m.96e2b2d3.jpg";